import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-more-info-modal',
    templateUrl: './more-info-modal.component.html',
    styleUrls: ['./more-info-modal.component.scss'],
    standalone: false
})
export class MoreInfoModalComponent implements OnInit {

  constructor(
    private matDialogRef: MatDialogRef<MoreInfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      header: string;
      body: string;
    }
  ) { }

  ngOnInit(): void {
  }

  closeModal() {
    this.matDialogRef.close();
  }
}
